import axios from "axios";
import { API_URL } from "../utils/apiUtils";

export const getDashboardService = async (startDate, endDate) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(`${API_URL}/dashboard`, {
      params: {
        startDate,
        endDate,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error fetching dashboard details"
    );
  }
};
